import React, { useState, useEffect } from 'react';
import { CardBody } from "reactstrap";
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '..';
import { VesselState, setVesselState, setReportID, getConfigurationLimitsAction, getCurrentReportAction, getPreviousReportAction, getLimitsAndAlertsAction, setCurrentReport, setSelectedOperations, getCurrentReportFilesAction } from "../Store/Generic/ReportingSlice";
import VoyageInformation from '../VoyageInformation/VoyageInformation';
import ToolTip from '../Components/ToolTip';
import CaptainIcon from '../Media/DC9.png';
import EngineerIcon from '../Media/E4.png';
import CaptainBlue from '../Media/DC3.png';
import EditIcon from '../Media/ED2.png';
import EngineerBlue from '../Media/E5.png';
import { DO_ENGG_ReportingStatus, offlineEditStatus, ReportingStatusConstant, Roles, VesselTypeConstant, VoyageConstant } from '../shared/constants';
import EditVesselReport from './EditVesselReport';
import { queryKeyes } from 'shared/queryKeys';
import { checkEditPermission, Get } from 'VesselMaster/vesselMaster.hooks';
import { useMutation, useQuery } from 'react-query';
import apiGlobal from 'global/api.global';
import ViewReport from '../Media/VD2.png'
import ViewReportModal from '../Components/ViewReportModal';
import SubmitErrorPopup from 'Components/SubmitErrorPopup';
import { hasRole } from 'utils/auth/authUtils';
import { queryClient } from 'react-query/queryClient';
import ErrorComponent from 'Components/ErrorComponent';
import VesselTableHeadComponent from './VesselTableHeadComponent';
import env from 'environment_system/env_system';
import { errResponse, formattooltip, generateReportName, calculateSpeed, checkValidObject, dateTimeFormat } from 'GenericForms/Helper';
import { errorToast, successToast } from 'Components/Toasts';
import PopOver from 'Components/PopOver';
import Message from 'Components/Message';
import WaitingPopup from 'Components/WaitingPopup';
import CompleteDisabledEngg from '../Media/CompletedDisabledEngg.png';
import EnggDisabled from '../Media/DisabledEngg.png';
import DisabledEdit from '../Media/ED2_disabled.png';
import CompletedDisabledDeck from '../Media/CompletedDisabledDeck.png';
import DisabledDeck from '../Media/DisabledDeck.png';
import PopUp from 'Components/PopUp';
import IsEditingWarning from './isEditingWarning';
import TableLoading from 'Components/TableLoading';
// import DeletePopOver from 'Components/DeletePopOver';
// import DeleteVoyagePopUp from './DeleteVoyagePopUp';
// import ReportExtraActions from 'Components/ReportExtraActions';
import { useEditReport } from './EditCompletedReports/EditReportProvider';
interface OngoingReportsProps {
    reports: any;
    reportsLoading: any;
    reportsError: any
}
const OngoingReports = ({ reports, reportsError, reportsLoading }: OngoingReportsProps) => {
    /** State variables */
    const [viewReport, setViewReport] = useState(false);
    const [submitError, setSubmitError] = useState(false);
    const [submitPopover, setSubmitPopover] = useState(false);
    const [submitReport, setSubmitReport] = useState(0);
    const [reportId, setReportId] = useState<number>(null);
    const [hoverId, setHoverId] = useState<string | null>(null);
    const dispatch = useDispatch();
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [RefreshKey, setRefreshKey] = useState(0);
    const [waitingBool, setWaitingBool] = useState(false);
    const [whichSENT, setWhichSENT] = useState<"DECK" | "ENGG" | ''>('');
    const { VesselState, Vessels, Voyages, VoyageID, VesselID, CurrentVessel, CurrentReport } = useSelector((state: RootState) => state.Reporting);
    const vessel = Vessels.find((rec: { [key: string]: string | number | boolean | Date }) => rec.id === VesselID);
    const isLNG = CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.LNG_CARRIER && CurrentVessel?.display === true ? true : false;
    const voyage = Voyages.find((rec: any) => rec.id === VoyageID);
    const [warningBool, setWarningBool] = useState(false);
    // const [deletePopOverState, setDeletePopOverState] = useState(false);
    // const [deleteTarget, setDeleteTarget] = useState<string>("");
    // const [deleteReportObj, setDeleteReportObj] = useState<any>({});
    // const [changeVoyageBool, setChangeVoyageBool] = useState(false);
    // const [changeVoyageErrorBool, setChangeVoyageErrorBool] = useState(false);
    // const [updatedVoyage, setUpdatedVoyage] = useState(null);
    // const [deleteVoyage, setDeleteVoyage] = useState(false);
    // const [deleteVoyagePopUp, setDeleteVoyagePopup] = useState(false);
    const { setActiveAddLfondsTab, setActiveAddEconTab, setActiveAddAryaTab } = useEditReport();
    /** State variables end */

    /** Set global state data */
    const handleVesselState = (reportId: number, state: VesselState) => {
        dispatch(setReportID(reportId))
        dispatch(setVesselState(state))
        dispatch(getConfigurationLimitsAction(VesselID))
        if (state !== 'CREATE_VESSEL_REPORTING') {
            dispatch(getCurrentReportAction(VesselID, reportId));
            dispatch(getCurrentReportFilesAction(reportId, VesselID))
            dispatch(getLimitsAndAlertsAction(`get_data_for_limits_and_alerts/?vessel_id=${VesselID}&load_condition=${loadingCondition}&speed=${calculateSpeed(
                ongoingReport?.length > 0 ? ongoingReport[0]?.distance_travelled : 0,
                ongoingReport?.length > 0 ? ongoingReport[0]?.time_duration_since_last_report : 0
            )}`));
        }
        if (state === 'CREATE_VESSEL_REPORTING') {
            dispatch(getPreviousReportAction(VesselID, reportId, true));
        } else {
            dispatch(getPreviousReportAction(VesselID, reportId));
        }
        dispatch(setSelectedOperations([]));
    }

    /** Queries start */
    /** Reports that are ongoing i.e. whose vessel_reporting_status is not SENT */
    const ongoingReport = reports
        ?.sort((a: any, b: any) => b.id - a.id)
        .filter((item: any) => item.vessel_reporting_status !== ReportingStatusConstant.SENT)
    /** useMutation */
    /** check edit permission and proceed */
    const { mutate: checkPermissionAndProceed, isLoading: isCheckingPermission, data: editingReport } = useMutation(
        async () => await checkEditPermission(VesselID, false),
        {
            onSuccess: (data: any) => {
                if (!data.status) {
                    setWarningBool(true);
                } else {
                    handleVesselState(-1, 'CREATE_VESSEL_REPORTING');
                }
            },
            onError: (error: any) => {
                console.error("Permission check failed", error);
            }
        }
    );
    /** Vessel general info object used for edit */
    const { data: VesselGenInfoObject }: { data: any[] } = useQuery(
        [queryKeyes.vessel.VesselGenInfoObject?.key, VesselID],
        async () => {
            return await Get(queryKeyes.vessel.VesselGenInfoObject.url(VesselID), VesselID);
        },
        {
            enabled: true,
            staleTime: 0,
        }
    );
    // const { data: lastVesselReport } = useQuery(
    //     [queryKeyes.vessel.LastVesselReport.key, VesselID],
    //     async () => await Get(queryKeyes.vessel.LastVesselReport.url(VesselID), VesselID),
    //     {
    //         staleTime: 0
    //     }
    // )
    /** Queries end */

    /** Function to check if the "Add new vessel" button is disabled or not */
    const isButtonDisabled = () => {
        if (vessel?.offline_edit_status === offlineEditStatus.OFFLINE_EDIT_REPORT_ACTIVATED) {
            return true;
        }

        if (!env?.offlineCopy && vessel?.is_vessel_offline) {
            return true;
        } else {
            if (isLNG) {
                if (reports && reports.length > 0 && reports?.[0]?.vessel_reporting_status === ReportingStatusConstant.OPEN) {
                    return true;
                }
            } else {
                if (voyage.voyage_status === VoyageConstant.COMPLETED) {
                    return true;
                }
                if (reports?.[0]?.vessel_reporting_status === ReportingStatusConstant.OPEN) {
                    return true;
                }
            }
            return false;
        }
    };

    /** Function to check if the vessel's load condition is laden or ballast */
    const checkCondition = (
        VesselGenInfoObject: any[],
        DraftsDisplacementObject: any
    ): "laden" | "ballast" | null => {
        if (checkValidObject(VesselGenInfoObject) && checkValidObject(DraftsDisplacementObject)) {
            return DraftsDisplacementObject?.draft_mid > VesselGenInfoObject[0]?.max_ballast_draft ? "laden" : "ballast";
        }
        return null;
    };
    const loadingCondition = checkCondition(VesselGenInfoObject, CurrentReport?.data?.deck_officer?.draft_and_displacement);

    useEffect(() => {
        queryClient.invalidateQueries(queryKeyes.vessel.vesselVoyageReporting.key);
        dispatch(getPreviousReportAction(VesselID, reportId, true));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [VesselID, reportId])

    const handleViewChanges = (id: number) => {
        setViewReport(true);
        setReportId(id);
    }

    const handleReportSubmit = async (report: any): Promise<any | null> => {
        setWaitingBool(true);
        try {
            if (isLNG) {
                if (env.desktop_app === false) {
                    await apiGlobal.post(`/submit/`, ({
                        vessel_id: VesselID,
                        vessel_reporting_information_id: report.id
                    })).then(() => {
                        apiGlobal.post(`/submit/`, ({
                            vessel_id: VesselID,
                            vessel_reporting_information_id: report.id
                        }));
                    });
                    const res = await apiGlobal.put(`/vessel_reporting_information/${report.id}/`, {
                        ...report,
                        vessel_reporting_status: ReportingStatusConstant.SENT
                    });
                    if (res?.status === 200) {
                        successToast("Report submitted successfully!");
                        await queryClient.invalidateQueries(queryKeyes.vessel.vesselVoyageReporting.key);
                        await queryClient.invalidateQueries(queryKeyes.pagination.completeReportPage.key);
                        await queryClient.invalidateQueries(queryKeyes.pagination.VoyageListPage.key);
                        await queryClient.invalidateQueries(queryKeyes.edit.checkongoingReport.key);
                        setRefreshKey(RefreshKey + 1);
                    }
                }
                const res = await apiGlobal.put(`/vessel_reporting_information/${report.id}/`, {
                    ...report,
                    vessel_reporting_status: ReportingStatusConstant.SENT
                });
                if (res?.status === 200) {
                    successToast("Report submitted successfully!");
                    await queryClient.invalidateQueries(queryKeyes.vessel.vesselVoyageReporting.key);
                    await queryClient.invalidateQueries(queryKeyes.pagination.completeReportPage.key);
                    await queryClient.invalidateQueries(queryKeyes.pagination.VoyageListPage.key);
                    await queryClient.invalidateQueries(queryKeyes.edit.checkongoingReport.key);
                    setRefreshKey(RefreshKey + 1);
                }
                setSubmitPopover(false);
                setWaitingBool(false);
                setReportId(null);
                return res.data;
            }
            const statusField = whichSENT === 'DECK'
                ? "officer_reporting_status"
                : "engineer_reporting_status";
            const res = await apiGlobal.patch(`/vessel_reporting_information/${report.id}/`, {
                [statusField]: ReportingStatusConstant.SENT
            });
            if (res?.status === 200) {
                successToast("Report submitted successfully!");
                await queryClient.invalidateQueries(queryKeyes.vessel.vesselVoyageReporting.key);
                await queryClient.invalidateQueries(queryKeyes.pagination.completeReportPage.key);
                await queryClient.invalidateQueries(queryKeyes.pagination.VoyageListPage.key);
                await queryClient.invalidateQueries(queryKeyes.edit.checkEditPermission.key);
                await queryClient.invalidateQueries(queryKeyes.edit.checkongoingReport.key);
                setRefreshKey(RefreshKey + 1);
            }
            setSubmitPopover(false);
            setWaitingBool(false);
            setReportId(null);
            return res.data;
        } catch (err: any) {
            if (errResponse.includes(err?.response?.status)) {
                errorToast(err?.response?.data?.error?.message ?? "Error submitting report !", false);
                setSubmitPopover(false);
                setWaitingBool(false);
            }
        }
    };

    return (
        <React.Fragment>
            {(voyage && (voyage.voyage_status !== VoyageConstant.CLOSED)) && (
                <div className='ele_row mb-2'>
                    <div>
                        <h4 id="owner_table" className="m-0">
                            Vessel Reporting Information
                        </h4>
                        <p className='mb-2'>
                            <b>Voyage Number:</b> {voyage?.voyage_number}
                        </p>
                    </div>
                    {(hasRole(Roles.ES_ADMIN) || hasRole(Roles.MASTER) || hasRole(Roles.ADMIN)) &&
                        <React.Fragment>
                            {/* Wrapper div for handling tooltip events */}
                            <div
                                id="create_vesssel_reporting"
                                onMouseEnter={() => { setTooltipOpen(true); }}
                                onMouseLeave={() => { setTooltipOpen(false); }}
                                style={{ display: "inline-block" }}
                            >
                                <button
                                    color="primary"
                                    className="btn btn-primary"
                                    disabled={isButtonDisabled()}
                                    onClick={() => {
                                        if (!isButtonDisabled()) {
                                            checkPermissionAndProceed(); // permission check and logic happens here
                                            dispatch(setCurrentReport(null));
                                        }
                                    }}
                                >
                                    {isCheckingPermission ? (
                                        <span className="spinner-border spinner-border-sm me-2" />
                                    ) : (
                                        <i className="dripicons-plus font-size-16 align-middle me-2" />
                                    )}
                                    Create New
                                </button>
                            </div>
                            {isButtonDisabled() && document.getElementById('create_vesssel_reporting') !== null &&
                                <ToolTip
                                    isOpen={tooltipOpen}
                                    target="create_vesssel_reporting"
                                    message={voyage?.voyage_status === VoyageConstant.COMPLETED
                                        ? "This voyage has already been completed."
                                        : "A new report cannot be created until the ongoing report is completed."}
                                    key={`${isButtonDisabled()}_${tooltipOpen}`}
                                />
                            }
                        </React.Fragment>
                    }
                </div>
            )}
            <CardBody className='p-0'>
                {(reportsLoading) && <TableLoading Rows={3} />}
                {reportsError && <ErrorComponent message="Error loading required data!" />}
                {((!reportsLoading && !reportsError)) &&
                    <table className="table mb-0" key={RefreshKey}>
                        <VesselTableHeadComponent reportStatus="ongoing" />
                        <tbody>
                            {ongoingReport.length > 0 &&
                                ongoingReport
                                    .map((report: any, index: number) => (
                                        <React.Fragment key={report.id}>
                                            <tr className="">
                                                <td className="p-2 align-middle text-center">{index + 1}</td>
                                                <td className="p-2 align-middle">{generateReportName(report)}</td>
                                                <td className="p-2 align-middle text-center">{report.reporting_type}</td>
                                                <td className="p-2 align-middle text-center">
                                                    {dateTimeFormat(report?.local_time, false, false, true)}
                                                </td>
                                                <td className="p-2 align-middle text-center">
                                                    <img
                                                        alt="View Report"
                                                        className={`align-middle pointer`}
                                                        src={ViewReport}
                                                        height="30"
                                                        id={`View_Details_${report.id}`}
                                                        onMouseEnter={() => setHoverId(`View_Details_${report.id}`)}
                                                        onMouseLeave={() => setHoverId(null)}
                                                        onClick={() => {
                                                            handleViewChanges(report.id);
                                                            setHoverId(null);
                                                        }}
                                                    />
                                                </td>
                                                {(hasRole(Roles.ES_ADMIN) || hasRole(Roles.MASTER) || hasRole(Roles.ADMIN)) && (
                                                    <td className="p-2 align-middle text-center">
                                                        <img
                                                            src={report?.vessel_reporting_status !== ReportingStatusConstant.OPEN ? DisabledEdit : EditIcon}
                                                            alt="Edit Icon"
                                                            height="30"
                                                            className="pointer"
                                                            id={report?.vessel_reporting_status !== ReportingStatusConstant.OPEN
                                                                ? `Report_Submitted_${report.id}`
                                                                : `Edit_Details_${report.id}`}
                                                            onMouseEnter={() => setHoverId(
                                                                report?.vessel_reporting_status !== ReportingStatusConstant.OPEN
                                                                    ? `Report_Submitted_${report.id}`
                                                                    : `Edit_Details_${report.id}`)}
                                                            onMouseLeave={() => setHoverId(null)}
                                                            style={{ opacity: report?.vessel_reporting_status !== ReportingStatusConstant.OPEN ? 0.5 : 1 }}
                                                            onClick={() => {
                                                                if (report?.vessel_reporting_status !== ReportingStatusConstant.OPEN) {
                                                                    return;
                                                                }
                                                                handleVesselState(report.id, 'EDIT');
                                                                setHoverId(null);
                                                            }}
                                                        />
                                                    </td>
                                                )}
                                                {(hasRole(Roles.ES_ADMIN) || hasRole(Roles.MASTER) || hasRole(Roles.ADMIN)) && (
                                                    <td className="p-2 align-middle text-center">
                                                        <img
                                                            alt="Deck Officer Report"
                                                            className="pointer"
                                                            src={
                                                                report.officer_reporting_status === DO_ENGG_ReportingStatus.COMPLETE
                                                                    ? CaptainBlue
                                                                    : report.officer_reporting_status === DO_ENGG_ReportingStatus.DISABLED
                                                                        ? DisabledDeck
                                                                        : report.officer_reporting_status === DO_ENGG_ReportingStatus.SENT
                                                                            ? CompletedDisabledDeck
                                                                            : CaptainIcon
                                                            }
                                                            height="30"
                                                            id={
                                                                report.officer_reporting_status === DO_ENGG_ReportingStatus.SENT
                                                                    ? `Deck_Officer_Report_Submitted_${report.id}`
                                                                    : report.officer_reporting_status === DO_ENGG_ReportingStatus.DISABLED
                                                                        ? `Disabled_Deck_Officer_Reporting_${report.id}`
                                                                        : `Deck_Officer_Reporting_${report.id}`
                                                            }
                                                            onMouseEnter={() =>
                                                                setHoverId(
                                                                    report.officer_reporting_status === DO_ENGG_ReportingStatus.SENT
                                                                        ? `Deck_Officer_Report_Submitted_${report.id}`
                                                                        : report.officer_reporting_status === DO_ENGG_ReportingStatus.DISABLED
                                                                            ? `Disabled_Deck_Officer_Reporting_${report.id}`
                                                                            : `Deck_Officer_Reporting_${report.id}`
                                                                )
                                                            }
                                                            onMouseLeave={() => setHoverId(null)}
                                                            style={{
                                                                opacity:
                                                                    report.officer_reporting_status === DO_ENGG_ReportingStatus.DISABLED ||
                                                                        report.officer_reporting_status === DO_ENGG_ReportingStatus.SENT
                                                                        ? 0.5
                                                                        : 1,
                                                            }}
                                                            onClick={() => {
                                                                if (
                                                                    report.officer_reporting_status === DO_ENGG_ReportingStatus.DISABLED ||
                                                                    report.officer_reporting_status === DO_ENGG_ReportingStatus.SENT
                                                                ) {
                                                                    return;
                                                                }
                                                                handleVesselState(report.id, 'DO_REPORTING');
                                                                setHoverId(null);
                                                                setActiveAddLfondsTab(1);
                                                                setActiveAddEconTab(1);
                                                                setActiveAddAryaTab(1);
                                                            }}
                                                        />
                                                    </td>
                                                )}
                                                {(hasRole(Roles.ES_ADMIN) || hasRole(Roles.MASTER) || hasRole(Roles.ADMIN)) && !isLNG &&
                                                    report.officer_reporting_status === DO_ENGG_ReportingStatus.COMPLETE &&
                                                    <td className="py-2 px-1 align-middle text-center">
                                                        <i
                                                            className="bx bx-send icon_s23 align-middle pointer "
                                                            id={`Submit_Deck_Report_${report.id}`}
                                                            onMouseEnter={() => setHoverId(`Submit_Deck_Report_${report.id}`)}
                                                            onMouseLeave={() => setHoverId(null)}
                                                            onClick={() => {
                                                                setWhichSENT('DECK')
                                                                setSubmitPopover(true);
                                                                setSubmitReport(report);
                                                                setReportId(report.id);
                                                                setHoverId(null);
                                                            }}
                                                        />
                                                        {reportId === report.id && submitError && (
                                                            <SubmitErrorPopup setState={setSubmitError} state={submitError} modalId={(report.id).toString()} />
                                                        )}
                                                    </td>
                                                }
                                                {(hasRole(Roles.ES_ADMIN) || hasRole(Roles.CHIEFENGINEER) || hasRole(Roles.ADMIN)) && (
                                                    <td className="p-2 align-middle text-center">
                                                        <img
                                                            alt="Engineer Report"
                                                            src={
                                                                report.engineer_reporting_status === DO_ENGG_ReportingStatus.COMPLETE
                                                                    ? EngineerBlue
                                                                    : report.engineer_reporting_status === DO_ENGG_ReportingStatus.DISABLED
                                                                        ? EnggDisabled
                                                                        : report.engineer_reporting_status === DO_ENGG_ReportingStatus.SENT
                                                                            ? CompleteDisabledEngg
                                                                            : EngineerIcon
                                                            }
                                                            className={`pointer`}
                                                            height="30"
                                                            id={
                                                                report.engineer_reporting_status === DO_ENGG_ReportingStatus.SENT
                                                                    ? `Report_submitted_${report.id}`
                                                                    : report.engineer_reporting_status === DO_ENGG_ReportingStatus.DISABLED
                                                                        ? `Disabled_Engineer_Reporting_${report.id}`
                                                                        : `Engineer_Reporting_${report.id}`
                                                            }
                                                            style={{
                                                                opacity:
                                                                    report.engineer_reporting_status === DO_ENGG_ReportingStatus.DISABLED ||
                                                                        report.engineer_reporting_status === DO_ENGG_ReportingStatus.SENT
                                                                        ? 0.5
                                                                        : 1,
                                                            }}
                                                            onMouseEnter={() =>
                                                                setHoverId(
                                                                    report.engineer_reporting_status === DO_ENGG_ReportingStatus.SENT
                                                                        ? `Report_submitted_${report.id}`
                                                                        : report.engineer_reporting_status === DO_ENGG_ReportingStatus.DISABLED
                                                                            ? `Disabled_Engineer_Reporting_${report.id}`
                                                                            : `Engineer_Reporting_${report.id}`
                                                                )
                                                            }
                                                            onMouseLeave={() => setHoverId(null)}
                                                            onClick={() => {
                                                                if (report.engineer_reporting_status === DO_ENGG_ReportingStatus.DISABLED || report.engineer_reporting_status === DO_ENGG_ReportingStatus.SENT) {
                                                                    return;
                                                                }
                                                                handleVesselState(report.id, 'ENGG_REPORTING');
                                                                setHoverId(null);
                                                                setActiveAddLfondsTab(1);
                                                                setActiveAddEconTab(1);
                                                                setActiveAddAryaTab(1);
                                                            }}
                                                        />
                                                    </td>
                                                )}
                                                {(hasRole(Roles.ES_ADMIN) || hasRole(Roles.CHIEFENGINEER) || hasRole(Roles.ADMIN)) && !isLNG &&
                                                    report.engineer_reporting_status === DO_ENGG_ReportingStatus.COMPLETE &&
                                                    <td className="py-2 px-1 align-middle text-center">
                                                        <i
                                                            className="bx bx-send icon_s23 align-middle pointer ms-2"
                                                            id={`Submit_Engineering_Report_${report.id}`}
                                                            onMouseEnter={() => setHoverId(`Submit_Engineering_Report_${report.id}`)}
                                                            onMouseLeave={() => setHoverId(null)}
                                                            onClick={() => {
                                                                setWhichSENT('ENGG')
                                                                setSubmitPopover(true);
                                                                setSubmitReport(report);
                                                                setReportId(report.id);
                                                                setHoverId(null);
                                                            }}
                                                        />
                                                        {reportId === report.id && submitError && (
                                                            <SubmitErrorPopup setState={setSubmitError} state={submitError} modalId={(report.id).toString()} />
                                                        )}
                                                    </td>
                                                }{
                                                    isLNG && report.engineer_reporting_status === DO_ENGG_ReportingStatus.COMPLETE && report.officer_reporting_status === DO_ENGG_ReportingStatus.COMPLETE &&
                                                    <td className="p-2 align-middle text-center">
                                                        <i
                                                            className="bx bx-send icon_s23 align-middle pointer ms-2"
                                                            id={`Submit_Report_${report.id}`}
                                                            onMouseEnter={() => setHoverId(`Submit_Report_${report.id}`)}
                                                            onMouseLeave={() => setHoverId(null)}
                                                            onClick={() => {
                                                                setSubmitPopover(true);
                                                                setSubmitReport(report);
                                                                setReportId(report.id);
                                                                setHoverId(null);
                                                            }}
                                                        />
                                                        {reportId === report.id && submitError && (
                                                            <SubmitErrorPopup setState={setSubmitError} state={submitError} modalId={(report.id).toString()} />
                                                        )}
                                                    </td>
                                                }
                                                {/* {
                                                    (hasRole(Roles.ES_ADMIN) || (hasRole(Roles.MASTER) && (report?.id === lastVesselReport?.id)) || hasRole(Roles.ADMIN)) &&
                                                    <td className="p-2 align-middle text-center">
                                                        <ReportExtraActions
                                                            report={report}
                                                            index={index}
                                                            setHoverId={setHoverId}
                                                            setDeleteReportObj={setDeleteReportObj}
                                                            setReportId={setReportId}
                                                            reportId={reportId}
                                                            lastVesselReport={lastVesselReport}
                                                            allReports={reports}
                                                            setDeleteTarget={setDeleteTarget}
                                                            setDeleteVoyageReport={setDeleteVoyagePopup}
                                                            setDeletePopOverState={setDeletePopOverState}
                                                            setUpdatedVoyage={setUpdatedVoyage}
                                                            setChangeVoyageBool={setChangeVoyageBool}
                                                            setChangeVoyageErrorBool={setChangeVoyageErrorBool}
                                                            reportStatus="ongoing"
                                                        />
                                                    </td>
                                                } */}
                                                {reportId === report.id && viewReport && (
                                                    <ViewReportModal
                                                        state={viewReport}
                                                        setState={setViewReport}
                                                        vesselId={VesselID}
                                                        reportId={reportId}
                                                        modalId={`${VesselID}${reportId}`}
                                                    />
                                                )}
                                            </tr>
                                        </React.Fragment>
                                    ))}
                            {ongoingReport?.length === 0 && (
                                <tr>
                                    <td colSpan={12} className="text-center p-3">
                                        <Message message="No ongoing reports available at the moment." type="danger" width="500px" />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                }
                {hoverId !== null && document.getElementById(hoverId) !== null &&
                    <ToolTip
                        target={hoverId}
                        message={formattooltip(hoverId)}
                        isOpen={hoverId !== null}
                    />
                }
            </CardBody>
            {VesselState === 'EDIT' && <EditVesselReport />}
            {VesselState === 'VOYAGE_REPORTING' && <VoyageInformation />}
            {submitPopover &&
                <PopOver
                    target={
                        whichSENT === 'DECK'
                            ? `Submit_Deck_Report_${reportId}`
                            : whichSENT === 'ENGG'
                                ? `Submit_Engineering_Report_${reportId}`
                                : `Submit_Report_${reportId}`
                    }
                    state={submitPopover}
                    setState={setSubmitPopover}
                    message="Are you sure you want to submit the form?"
                    handleClick={() => handleReportSubmit(submitReport)}
                />
            }
            {/* {deleteVoyagePopUp &&
                <PopUp
                    state={deleteVoyagePopUp}
                    setState={setDeleteVoyagePopup}
                    title="Delete Voyage"
                    body={<DeleteVoyagePopUp
                        voyage={voyage}
                        setDeleteVoyagePopup={setDeleteVoyagePopup}
                        deleteReportObj={deleteReportObj}
                        setRefreshKey={setRefreshKey}
                        setDeletePopOverState={setDeletePopOverState}
                    />}
                    size="sm"
                />
            }
            {changeVoyageBool &&
                <PopUp
                    state={changeVoyageBool}
                    setState={setChangeVoyageBool}
                    title="Change Voyage"
                    size="sm"
                    body={
                        <React.Fragment>
                            <Row className='mb-2'>
                                <Col lg={12}>
                                    <p className='mb-2'>Current voyage: <strong>{voyage?.voyage_number}</strong></p>
                                    <p>New voyage: <strong>{updatedVoyage?.voyage?.voyage_number}</strong></p>
                                </Col>
                            </Row>
                            {reports && reports?.length === 1 &&
                                <Row className='mb-2'>
                                    <Col lg={9}>
                                        <p>Do you want to delete the voyage as well?</p>
                                    </Col>
                                    <Col lg={3}>
                                        <div className="square-switch mt-1">
                                            <Input
                                                type="checkbox"
                                                switch="none"
                                                id={`delete_voyage`}
                                                name={`delete_voyage`}
                                                onChange={(e: any) => setDeleteVoyage(e.target.checked)}
                                            />
                                            <Label
                                                htmlFor="delete_voyage"
                                                data-on-label="Yes"
                                                data-off-label="No"
                                                className="mt-1"
                                                tabIndex={0}
                                                onKeyDown={(e) => {
                                                    if (e.key === " " || e.key === "Enter") {
                                                        e.preventDefault();
                                                        document.getElementById("delete_voyage")?.click();
                                                    }
                                                }}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            }
                            <Button
                                type="button"
                                color="primary"
                                className="btn_size_cstm justify_right"
                                onClick={() => {
                                    if (deleteVoyage) {
                                        apiGlobal.post(`/shift_report_to_voyage/`, {
                                            report_id: reportId,
                                            delete_empty_voyage: true
                                        }).then(async res => {
                                            if (res?.status === 200) {
                                                successToast("Voyage changed successfully!");
                                                setChangeVoyageBool(false);
                                                setDeleteVoyage(false);
                                                dispatch(setVesselState("VOYAGE_REPORTING"));
                                                await queryClient.invalidateQueries(queryKeyes.vessel.vesselVoyageReporting.key);
                                                await queryClient.invalidateQueries(queryKeyes.vessel.LastVesselReport.key);
                                            }
                                        }).catch(() => {
                                            errorToast("Error changing voyage!");
                                            setChangeVoyageBool(false);
                                            setDeleteVoyage(false);
                                        });
                                    } else {
                                        apiGlobal.post(`/shift_report_to_voyage/`, {
                                            report_id: reportId,
                                        }).then(async res => {
                                            if (res?.status === 200) {
                                                successToast("Voyage changed successfully!");
                                                setChangeVoyageBool(false);
                                                setDeleteVoyage(false);
                                                await queryClient.invalidateQueries(queryKeyes.vessel.vesselVoyageReporting.key);
                                                await queryClient.invalidateQueries(queryKeyes.vessel.LastVesselReport.key);
                                            }
                                        }).catch(() => {
                                            errorToast("Error changing voyage!");
                                            setChangeVoyageBool(false);
                                        });
                                    }
                                }}
                            >
                                Change Voyage
                            </Button>
                        </React.Fragment>
                    }
                />
            }
            {changeVoyageErrorBool &&
                <PopUp
                    state={changeVoyageErrorBool}
                    setState={setChangeVoyageErrorBool}
                    size="sm"
                    title="Error"
                    body={<Message type="danger" message="This report's voyage cannot be changed!" />}
                />
            } */}
            {warningBool && (
                <PopUp
                    state={warningBool}
                    setState={setWarningBool}
                    title="Warning"
                    size="md"
                    body={
                        <IsEditingWarning
                            onContinue={() => {
                                apiGlobal.get(queryKeyes.edit.checkEditPermission.url(VesselID, true)).then(res => {
                                    if (res.status === 200) {
                                        successToast("Permission revoked successfully!");
                                        handleVesselState(-1, 'CREATE_VESSEL_REPORTING');
                                        queryClient.invalidateQueries(queryKeyes.edit.checkEditPermission.key);
                                        setWarningBool(false);
                                    }
                                }).catch(err => {
                                    console.error(err);
                                });
                            }}
                            ReportName={generateReportName(editingReport?.record)}
                            ReportTime={editingReport?.record?.local_time?.slice(0, 10)}
                        />
                    }
                />
            )}
            {waitingBool &&
                <WaitingPopup
                    state={waitingBool}
                    setState={setWaitingBool}
                    message={"Processing your request, please wait..."}
                />
            }
            {/* {deletePopOverState && document.getElementById(deleteTarget) != null &&
                <DeletePopOver
                    target={deleteTarget}
                    onClick={async () => {
                        await handleDeleteReport(deleteReportObj, setRefreshKey, setDeletePopOverState, false);
                        queryClient.refetchQueries(queryKeyes.edit.checkongoingReport.key);
                        queryClient.refetchQueries(queryKeyes.edit.checkEditPermission.key);
                        queryClient.invalidateQueries(queryKeyes.vessel.vesselVoyageReporting.key);
                        queryClient.invalidateQueries(queryKeyes.vessel.LastVesselReport.key);
                        setHoverId(null);
                    }}
                    state={deletePopOverState}
                    setState={setDeletePopOverState}
                />
            } */}
        </React.Fragment >
    )
}

export default OngoingReports